import { createFileRoute } from '@tanstack/react-router';
import { useTranslations } from 'use-intl';
import { RouterLinkAs } from '@/lib/router-link';
import {
  Card,
  I,
  Icon,
  ListItem,
  List,
  PageHeader,
  Screen,
  ScreenBody,
  SettingIcon,
} from '@leanin/ui';
import type { IconName, Tone } from '@leanin/ui';
import { SignOutRow } from './-components/SignOutRow';

type Section = {
  readonly id:
    | 'profile'
    | 'notifications'
    | 'email'
    | 'privacy'
    | 'sessions'
    | 'connected'
    | 'dsr';
  readonly icon: IconName;
  readonly tone: Tone;
  readonly href: string;
};

const SECTIONS: readonly Section[] = [
  {
    id: 'profile',
    icon: 'users',
    tone: 'burgundy',
    href: '/settings/account',
  },
  {
    id: 'notifications',
    icon: 'bell',
    tone: 'emerald',
    href: '/settings/notifications',
  },
  {
    id: 'email',
    icon: 'bell',
    tone: 'yellow',
    href: '/settings/email',
  },
  {
    id: 'privacy',
    icon: 'lock',
    tone: 'navy',
    href: '/settings/privacy',
  },
  {
    id: 'sessions',
    icon: 'shield',
    tone: 'emerald',
    href: '/settings/sessions',
  },
  {
    id: 'connected',
    icon: 'network',
    tone: 'neutral',
    href: '/settings/connected',
  },
  {
    id: 'dsr',
    icon: 'book',
    tone: 'neutral',
    href: '/settings/dsr',
  },
];

export const Route = createFileRoute('/_authed/settings/')({
  component: SettingsHubPage,
});

function SettingsHubPage() {
  const t = useTranslations('Settings');
  return (
    <Screen>
      <ScreenBody gap="2xl">
        <PageHeader title={t('hub.title')} />
        <Card pad="flush">
          <List bordered={false}>
            {SECTIONS.map((s) => (
              <ListItem
                key={s.id}
                linkAs={RouterLinkAs}
                href={s.href}
                leading={<SettingIcon tone={s.tone}>{I[s.icon]}</SettingIcon>}
                title={t(`hub.sections.${s.id}.label`)}
                subtitle={t(`hub.sections.${s.id}.description`)}
                trailing={<Icon size={18}>{I.arrow}</Icon>}
              />
            ))}
          </List>
        </Card>

        <Card pad="flush">
          <List bordered={false}>
            <ListItem
              linkAs={RouterLinkAs}
              href="/help"
              leading={<SettingIcon tone="neutral">{I.globe}</SettingIcon>}
              title={t('hub.sections.help.label')}
              subtitle={t('hub.sections.help.description')}
              trailing={<Icon size={18}>{I.arrow}</Icon>}
            />
            <SignOutRow />
          </List>
        </Card>
      </ScreenBody>
    </Screen>
  );
}
